<template>
    <div>
      <ssg-messagebox
        titles="新增黑名单成员"
        v-if="maskshow"
        @sub="submitMember"
        @shut="closeDialog"
        width="500px"
        height="auto"
      >
        <div class="form">
          <el-form
            :model="memberForm"
            :rules="memberRules"
            ref="memberForm"
            label-width="100px"
            label-position="right"
          >
            <el-form-item label="姓名" prop="name" haveto="true" style="margin-bottom: 20px">
              <el-input
                v-model.trim="memberForm.name"
                placeholder="请输入姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard" haveto="true" style="margin-bottom: 20px">
              <el-input
                v-model.trim="memberForm.idCard"
                placeholder="请输入身份证号"
                maxlength="18"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark" style="margin-bottom: 20px">
              <el-input
                type="textarea"
                v-model.trim="memberForm.remark"
                placeholder="请输入备注"
                :rows="4"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </ssg-messagebox>
      <div class="header">
        <div class="left">
          <div class="logo">
            <img src="../../assets/img/logossg.png" />
          </div>
          <div class="line"></div>
          <div class="back" @click="back">返回项目列表</div>
        </div>
  
        <div class="company">{{ this.$route.query.projectName }}</div>
      </div>
      <div class="content" v-if="edit == false">
        <div class="leftdiv">
          <div class="leftnav">
            <div class="title">员工黑名单</div>
            <div class="tip">
              <div>该名单员工在进行推送合同时，会进行提醒潜在风险</div>
              <div>请运营人员谨慎办理入职</div>
            </div>
            <div class="line"></div>
           
            <div>
              <div class="contentlist">
                <div class="contentline"></div>
                <div class="block" v-for="(m, l) in recordList" :key="l">
                  <div class="time">{{ m.createTime }}</div>
                  <div class="tipnum">
                    <span class="tip1">{{ m.content }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightdiv">
    
          <div class="nav" >
            <div>
              <span style="margin-right: 20px">身份证号筛选</span>
              <el-input
                v-model.trim="idCardFilter"
                placeholder="请输入身份证号"
                maxlength="18"
                style="width: 260px"
                @keyup.enter.native="searchByIdCard"
                clearable
                @clear="searchByIdCard"
              ></el-input>
            </div>
            <div data-permissions="view:ssg:employ:blocklist:add" v-has>
              <button class="btn subbtn" @click="addMember">新增成员</button>
            </div>
          </div>
          <div class="tablediv">
            <div class="ibox" style="margin-bottom: 0">
              <div class="table">
                <h4>员工黑名单</h4>
              </div>
            </div>
            <div class="table">
              <el-table
                :data="list"
                :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
              >
                <el-table-column
                  label="姓名"
                  prop="name"
                  min-width="12"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  label="身份证号"
                  prop="idnumber"
                  min-width="15"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  label="备注"
                  prop="remark"
                  min-width="15"
                  
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  prop="status"
                  min-width="13"
                  align="right"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <span @click="remove(scope.row.id)" style="color: #6669e3; cursor: pointer;">移出</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <page
              :page="pageNum"
              :pagesize.sync="pageSize"
              :total="total"
              @currentChange="cur"
              @enter="cur"
              v-show="total > 0"
              :pageNum="pageNum"
            ></page>
          </div>
        </div>
      </div>
      <div class="authority" v-if="edit == true">
        <div class="content">
          <p>您没有权限查看页面</p>
          <p>如需开通请联系系统管理员</p>
        </div>
      </div>
    </div>
  </template>
    <script>
  export default {
    created() {
      let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
     
      this.loadData();
      this.operation();
    },
  
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        edit: false,
        idCardFilter: "",
        maskshow: false,
        memberForm: {
          name: "",
          idCard: "",
          remark: "",
        },
        memberRules: {
          name: [
            {
              required: true,
              message: "请输入姓名",
              trigger: "blur",
            },
            {
              pattern: /^[\u4e00-\u9fa5·]{2,20}$/,
              message: "姓名格式不正确",
              trigger: "blur",
            },
          ],
          idCard: [
            {
              required: true,
              message: "请输入身份证号",
              trigger: "blur",
            },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: "身份证号格式不正确",
              trigger: "blur",
            },
          ],
        },
        recordList: [{}],
        list: [],
      };
    },
    computed: {
      /** 与 axios 中 baseURL8 同源：.env 的 VUE_APP_BASEURLSERVICEELSE2 */
      blocklistBaseURL() {
        return (
          process.env.VUE_APP_BASEURLSERVICEELSE2 ||
          this.$axios.defaults.baseURL8
        );
      },
    },
    methods: {
      searchByIdCard() {
        this.pageNum = 1;
        this.loadData();
      },
      addMember() {
        this.memberForm = {
          name: "",
          idCard: "",
          remark: "",
        };
        this.maskshow = true;
        this.$nextTick(() => {
          if (this.$refs.memberForm) {
            this.$refs.memberForm.clearValidate();
          }
        });
      },
      closeDialog() {
        this.maskshow = false;
        if (this.$refs.memberForm) {
          this.$refs.memberForm.resetFields();
        }
      },
      submitMember() {
        this.$refs.memberForm.validate((valid) => {
          if (!valid) return;
          this.$axios
            .post(
              "/blocklist/add",
              {
                name: this.memberForm.name,
                idnumber: this.memberForm.idCard,
                remark: this.memberForm.remark,
              },
              { baseURL: this.blocklistBaseURL }
            )
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.closeDialog();
                this.loadData();
                this.operation();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        });
      },
      operation() {
        const params = {
          pageNo: 1,
          pageSize: 10,
        };
        return this.$axios
          .get("/blocklist/records", {
            params,
            baseURL: this.blocklistBaseURL,
          })
          .then((res) => {
            if (res.data.status == 1) {
              this.recordList = res.data.data;
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      },
      remove(id) {
        this.$confirm("确定移出黑名单列表吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$axios
            .post("/blocklist/" + id + "/remove", {}, {
              baseURL: this.blocklistBaseURL,
            })
            .then((res) => {
            if(res.data.status == 1) {
              this.$message.success(res.data.message);
              this.loadData();
              this.operation();
            } else {
              this.$message.error(res.data.message);
            }
          });
        });
      },
      loadData() {
        const params = {
          name: this.idCardFilter || "",
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        };
        this.$axios
          .get("/blocklist/list", {
            params,
            baseURL: this.blocklistBaseURL,
          })
          .then((res) => {
            if (res.data.status == 1) {
              this.list = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      },

         cur(val) {
        this.pageNum = val;
        this.loadData();
      },
      back() {
        this.$router.push({
          path: "/ssgSplat",
        });
      },
  
    },
  };
  </script>
    
    
    <style src="../../assets/css/common/nav.less" scoped lang="less"></style>
    <style src="../../assets/css/common/operating.less" scoped lang="less"></style>
    <style src="../../assets/css/common/table.less" scoped lang="less"></style>
    <style src="../../assets/css/common/card.less" scoped lang="less"></style>
    <style src="../../assets/css/common/details.less" scoped lang="less"></style>
  <style src="../../assets/css/common/eattribute.less" scoped lang="less"></style>
  
    <style scoped lang="less">
  .header {
    height: 63px;
    background-color: #f2f5f8;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  
    .left {
      display: flex;
      align-items: center;
    }
    .line {
      width: 1px;
      height: 21px;
      background-color: #d9dbe2;
      margin: 0 37px;
    }
    .back {
      font-size: 12px;
      font-weight: 400;
      color: rgba(102, 105, 227, 1);
      cursor: pointer;
    }
    .logo {
      margin-left: 30px;
    }
  }
  .content {
    display: flex;
    margin: 50px 100px;
  
    .leftdiv {
      width: 20%;
      height: 100%;
      border: 1px solid #d9dbe2;
      border-radius: 15px;
      .leftnav {
        padding: 20px;
        .title {
          font-weight: 700;
          color: #303140;
          font-size: 18px;
          margin: 20px 0;
        }
        .tip {
          margin: 40px 0 100px 0;
          font-size: 12px; 
          font-weight: 400;
          color: #8a8a9a;
          line-height: 20px;
        }
        .line {
          height: 1px;
          background: #4e5969;
          text-align: center;
          margin: 20px -20px;
        }
        .tabdiv {
          // margin-bottom: 50px;
        }
      }
    }
  }
  .authority {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 100px auto;
  
    .content {
      text-align: center;
      margin: 50px auto;
      font-size: 24px;
      font-weight: bold;
      color: #303140;
      justify-content: center;
    }
  }
  .contentlist {
    display: block;
    font-size: 14px;
  
    .contentline {
      width: 1px;
      margin-right: 25px;
      background-color: #d9dbe2;
      display: inline;
    }
    .block {
      margin-bottom: 10px;
    }
    .time {
      color: #8a8a;
    }
    .tip1 {
      color: #303140;
      margin-right: 3px;
    }
    .tip2 {
      color: #6669e3;
      margin-left: 3px;
    }
  }
  .rightdiv {
    margin-left: 100px;
    width: 70%;
    .tablediv {
      margin-top: 50px;
    }
    .nav {
      display: flex;
      justify-content: space-between;
    }
  }
  </style>
    